module.exports = __webpack_public_path__ + "static/media/denglu02.3d5cfa7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginImg/denglu02.mp4
// module id = C0nW
// module chunks = 18